let couponTpl = require('./coupon.tpl.html');
import * as EQualOneUIService from "../../services/EQualOneUIService";

class CouponController {
    constructor($equalOneUIService, $timeout) {
        this.$equalOneUIService = $equalOneUIService;
        this.$timeout = $timeout;
        this.coupon = "";
        /*
        result of the JS lig to load coupon
        res==0: success
        res==1: scenario already up-to-date
        res==2: error

        we add 2 values for nice display on the UI
        res==-2: ready
        res==-1: coupon loading
         */
        this.res = -2;
        this.enabled = $equalOneUIService.enabled;
    }

    submit() {

        this.res = -1;
        this.$equalOneUIService.couponLoading(this.coupon, (res)=> {
            this.res = res;
            this.$timeout(() => {
                this.res = -2;
            }, 3000);
        });
    }
}

CouponController.$inject = ['EQualOneUIService', '$timeout'];

let Coupon = {
    bindings: {},
    templateUrl: couponTpl,
    controller: CouponController
};


export default Coupon;



// WEBPACK FOOTER //
// ./src/equalone-ui/components/coupon/coupon.component.js